<div class="gpd-full-page setup-wizard-page" *ngIf="!isConfigured && !isLoading">
  <app-setup-wizard (onComplete)="onSetupComplete()" (onCancel)="onSetupCancel()"></app-setup-wizard>
</div>

<div class="gpd-full-page overview-page" *ngIf="isConfigured && !isLoading">
  <app-project-config-overview></app-project-config-overview>
</div>